import script from "./podcast-card.vue?vue&type=script&setup=true&lang=js"
export * from "./podcast-card.vue?vue&type=script&setup=true&lang=js"

import "./podcast-card.vue?vue&type=style&index=0&id=a3770a5e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3770a5e"]])

export default __exports__